import { ReactNode } from 'react';

import { MentionData, MentionType } from '../consts';

export default function reactStringReplace(
  text?: string,
  regex?: RegExp,
  callback?: (mention: MentionData, index: number) => ReactNode
): ReactNode[] {
  if (!text) return [];
  if (!regex) return [];

  let result = text;
  let prevIndex = 0;
  const textParts: ReactNode[] = [];

  Array.from(text.matchAll(regex)).map((found, key) => {
    const [template, type, id, name] = found;
    const index = found.index || 0;
    textParts.push(text.substring(prevIndex, index));
    textParts.push(callback?.({ id, name, type: type as MentionType }, key));
    result = text.substring(index + template.length);
    prevIndex = index + template.length;
  });

  textParts.push(result);

  return textParts.filter((_) => _);
}
